import "./filtros.css";
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InputDate, Label, Boton, Input } from "asocomponents"
import { addFiltrosFacturas, addFiltroRapidoFacturas, setFiltrosCargados } from '../../../redux/filtroFacturasSlice'
import SelectEstadoFactura from "../Selects/SelectEstadoFactura/SelectEstadoFactura";
import BuscadorJuicios from "../Buscadores/BuscadorJuicios/BuscadorJuicios";
import SelectPrestador from "../Selects/SelectPrestador/SelectPrestador";
import ExportarExcel from "../ExportarExcel/ExportarExcel";
import { Link } from 'react-router-dom'

export default function FiltrosFacturas() { 
  const dispatch = useDispatch()
  const fechaActual = new Date()
  const filtrosCargados = useSelector(state => state.rootReducer.filtrosFacturas.cargados)
  const dataGrillaFactura = useSelector(state => state.rootReducer.resultadoGrillaFacturaJuicio.dataGrillaFactura)
  const usuarioString = sessionStorage.getItem('usuario') ? JSON.parse(sessionStorage.getItem('usuario')) : null;
  const camposExportarExcel = ["fechaFac", "tipoFactura", "cuitPrestador", "razonSocialPrestador", "nroFactura", "caratulaJuicio", "importe", "estado"];

  fechaActual.setDate(fechaActual.getDate() + 1);
  fechaActual.setHours(0, 0, 0, 0); // Establecer la hora, minutos, segundos y milisegundos a 0

  const fechaMenos365Dias = new Date()
  fechaMenos365Dias.setDate(fechaMenos365Dias.getDate() - 20)

  const [isOpen, setIsOpen] = useState(false)
  const [fechaFacturaDesde, setFechaFacturaDesde] = useState()
  const [fechaFacturaHasta, setFechaFacturaHasta] = useState()
  const [fechaGrabacionDesde, setFechaGrabacionDesde] = useState(fechaMenos365Dias.toISOString().split('T')[0])
  const [fechaGrabacionHasta, setFechaGrabacionHasta] = useState(fechaActual.toISOString().split('T')[0])
  const [nroFactura, setNroFactura] = useState()
  const [ptoVenta, setPtoVenta] = useState()
  const [estadoFactura, setEstadoFactura] = useState(1)
  const [cuitLetrado, setCuitLetrado] = useState(usuarioString?.usuario)
  const [palabraBuscar, setPalabraBuscar] = useState()
  const [idJuicio, setIdJuicio] = useState(-1)
  const [idPrestador, setIdPrestador] = useState(null)

  const completarCerosPtoVta = (event) => {
    const valor = event.target.value
    setPtoVenta(valor.toString().padStart(4, '0'))
  }

  const completarCerosNroFac = (event) => {
    const valor = event.target.value
    setNroFactura(valor.toString().padStart(8, '0'))
  }

  const handleFiltros = () => {
    const filtros = {
      fechaAltaInicio: fechaGrabacionDesde,
      fechaAltaFin: fechaGrabacionHasta,
      fechaFacturaInicio: fechaFacturaDesde,
      fechaFacturaFin: fechaFacturaHasta,
      nroFactura: (ptoVenta != null ? `${String(ptoVenta)}-${String(nroFactura ?? '')}` : String(nroFactura ?? '')),
      idEstadoLiquidacionWeb: estadoFactura,
      idJuicio: idJuicio,
      cuitLetrado: cuitLetrado,
      idPrestador: idPrestador
    }

    dispatch(addFiltrosFacturas(filtros))
    dispatch(setFiltrosCargados(!filtrosCargados))

    toggleMenu()
  }

  const handleFechaFacturaDesde = (valor) => {
    setFechaFacturaDesde(valor)
  }

  const handlePrestador = (event) => {
    const valor = event.target.value
    if (valor > 0) {
      setIdPrestador(valor)
    }
  }

  const handlePtoVenta = (valor) => {
    setPtoVenta(valor)
  }

  const handleFechaFacturaHasta = (valor) => {
    setFechaFacturaHasta(valor)
  }

  const handleFechaGrabacionDesde = (valor) => {
    setFechaGrabacionDesde(valor)
  }

  const handleFechaGrabacionHasta = (valor) => {
    setFechaGrabacionHasta(valor)
  }

  const handleNroFactura = (valor) => {
    setNroFactura(valor)
  }
  const handleEstadoFactura = (event) => {
    const valor = event.target.value
    setEstadoFactura(valor)
  }

  const handlePalabraBuscar = (valor) => {
    setPalabraBuscar(valor)
    if (valor.length > 3) {
      dispatch(addFiltroRapidoFacturas(valor))
    }
    else {
      dispatch(addFiltroRapidoFacturas(''))
    }
  }
  const handleJuicio = async (juicio) => {
    setIdJuicio(juicio.idJuicio)
    setIsOpen(isOpen)
  }

  const toggleMenu = () => {
    setIsOpen(!isOpen)
    localStorage.setItem("filtrosOpen", (!isOpen).toString())
  };

  useEffect(() => {
    handleFiltros()
  }, [])

  return (
    <>
      <div className="flex flex-row justify-between m-3 w-[99%]">
        <div className="flex justify-start">
          <Input placeholder="Buscar" type="text" valor={palabraBuscar} onChange={handlePalabraBuscar} width="w-44" /> <Boton icono="filtro" onClick={toggleMenu} alt="Ver Filtros" colorIcon="#5a5a5a" />
        </div>
      </div>
      <div className={`overlay ${!isOpen ? "open" : ""}`} onClick={toggleMenu}></div>
      <div className={`floating-filtros ${isOpen ? "open" : ""}`}>
        <div className="filtros-content">
          <div className="flex flex-row justify-between items-center">
            <Label texto="FILTROS" size="text-m" /> <Boton icono="quitar" onClick={toggleMenu} alt="Cerrar" />
          </div>
          <div><hr /></div>
          <div className="flex flex-col mt-8">
            <div className="flex flex-row ml-5">
              <div className="text-left w-[50%]">
                <Label texto="Fecha Grab. Desde" />
              </div>
              <div className="text-left w-[50%]">
                <Label texto="Fecha Grab. Hasta" /></div>
            </div>
            <div className="flex flex-row">
              <div className="text-left w-[50%]">
                <InputDate valor={fechaGrabacionDesde} onChange={handleFechaGrabacionDesde} />
              </div>
              <div className="text-left w-[50%]">
                <InputDate valor={fechaGrabacionHasta} onChange={handleFechaGrabacionHasta} />
              </div>
            </div>
            <div className="flex flex-row ml-5 mt-3">
              <div className="text-left w-[50%]">
                <Label texto="Fecha Fac. Desde" />
              </div>
              <div className="text-left w-[50%]">
                <Label texto="Fecha Fac. Hasta" /></div>
            </div>
            <div className="flex flex-row">
              <div className="text-left w-[50%]">
                <InputDate valor={fechaFacturaDesde} onChange={handleFechaFacturaDesde} />
              </div>
              <div className="text-left w-[50%]">
                <InputDate valor={fechaFacturaHasta} onChange={handleFechaFacturaHasta} />
              </div>
            </div>
            <div className="flex flex-row ml-5 mt-3">
              <div className="text-left w-[50%]">
                <Label texto="Factura" />
              </div>
              <div className="text-left w-[50%]">
              </div>
            </div>
            <div className="flex flex-row ml-3">
              <Input type="number" placeholder="Pto. Vta" valor={ptoVenta} onChange={handlePtoVenta} width='w-28' maxlength="4" onBlur={completarCerosPtoVta} /><Label texto="-" /><Input type="number" placeholder="N° Factura" valor={nroFactura} onChange={handleNroFactura} width='w-32' maxlength="8" onBlur={completarCerosNroFac} />
            </div>
            <div className="flex flex-row ml-5 mt-3">
              <div className="text-left w-[50%]">
                <Label texto="Estado" />
              </div>
              <div className="text-left w-[50%]">
                <Label texto="Prestador" />
              </div>
            </div>
            <div className="flex flex-row">
              <div className="text-left w-[50%] ml-3">
                <SelectEstadoFactura valor={estadoFactura} onChange={handleEstadoFactura} width="w-32" todos={true} />
              </div>
              <div className="text-left w-[50%]">
                <SelectPrestador idLetrado={usuarioString && usuarioString.idusuario} valor={idPrestador} onChange={handlePrestador} width="w-32" todos={false} />
              </div>
            </div>
            <div className="flex flex-row ml-5 mt-3">
              <div className="text-left w-[50%]">
                <Label texto="P. Judicial" />
              </div>
              <div className="text-left w-[50%]">
              </div>
            </div>
            <div className="flex flex-row">
              <div className="text-left w-[50%] ml-3">
                <BuscadorJuicios onChange={handleJuicio} cuitLetrado={cuitLetrado} width="w-20" referente="administrativo"/>
              </div>
              <div className="text-left w-[50%]">
              </div>
            </div>
            <div className="flex flex-row ml-5 mt-6 mb-3 justify-center items-center">
              <Boton texto="Aplicar" fondo="rojo" onClick={handleFiltros} alt="Buscar" height="h-8" />
            </div>

          </div>
        </div>
      </div>
      <div className="flex flex-col justify-end">
        <div className="flex flex-row justify-end m-4">
          <Link to={"../nuevaFactura"}><Boton texto="Nueva Factura" type="button" fondo="rojo" width="w-32" height="h-9" /></Link>
        </div>
        <div className="flex justify-end mr-5">
          <ExportarExcel data={dataGrillaFactura} nombreArchivo={"ReporteFacturas"} camposSeleccionados={camposExportarExcel} />
        </div></div>
    </>
  )
}
